module.exports = __webpack_public_path__ + "static/media/4.0a8d8785.jpg";